import { XCircleIcon } from '@heroicons/react/24/outline';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StatusCard } from '@/shared/ui';

type FailedChatViewProps = {
  /** エラー説明文（未指定の場合は汎用メッセージを表示） */
  description?: string;
  buttonText: string;
  onButtonClick: () => void;
};

/**
 * 失敗チャットビュー（エラー表示）
 */
export const FailedChatView: FC<FailedChatViewProps> = ({
  description,
  buttonText,
  onButtonClick,
}) => {
  const { t } = useTranslation();
  return (
    <StatusCard
      title={t('ai.errors.analysis-failed-title')}
      description={description || t('ai.errors.analysis-failed-description')}
      icon={<XCircleIcon className="size-8 text-text-error" />}
      buttonText={buttonText}
      onButtonClick={onButtonClick}
    />
  );
};
